const shortNumber = value => {
  if (!value) {
    return 0;
  }

  if (value < 1000) {
    return value;
  }

  const powers = [
    { key: 'q', step: Math.pow(10, 15) },
    { key: 't', step: Math.pow(10, 12) },
    { key: 'b', step: Math.pow(10, 9) },
    { key: 'm', step: Math.pow(10, 6) },
    { key: 'k', step: 1000 },
  ];

  for (const { key, step } of powers) {
    const reduced = value / step;
    if (reduced >= 1) {
      return Math.round(reduced) + key;
    }
  }

  return value;
};

export default shortNumber;
